import { render, staticRenderFns } from "./upload-case.vue?vue&type=template&id=60f0d647&scoped=true&"
import script from "./upload-case.vue?vue&type=script&lang=js&"
export * from "./upload-case.vue?vue&type=script&lang=js&"
import style0 from "./upload-case.vue?vue&type=style&index=0&id=60f0d647&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0d647",
  null
  
)

export default component.exports